import React, { ReactElement } from 'react';

import { useTheme } from '@24i/nxg-sdk-higgs';
import { View, Text } from '@24i/nxg-sdk-quarks';
import PackshotGrid from '@24i/nxg-sdk-gluons/src/components/containers/PackshotGrid';
import Loader from '@24i/nxg-sdk-gluons/src/components/ui/Loader';

import { withWebHeader } from '../../../navigation/components/withWebHeader';
import getGenreScreenStyles from '../styles/index.web';
import { GenreWebProps } from '../types';
import { WithWebHeaderProps } from '../../../navigation/components/withWebHeader/types';

const GenreScreen = ({
    genreAssets = [],
    selectedGenre = '',
    styles: getStyles = getGenreScreenStyles,
    handlePackshotPress,
    isLoading,
    gridContainerRef,
}: GenreWebProps): ReactElement => {
    const { theme } = useTheme();
    const styles = getStyles(theme);

    return (
        <View style={styles.holder} ref={gridContainerRef}>
            <View style={styles.pickerHolder}>
                <Text style={styles.sectionTitle}>{selectedGenre}</Text>
            </View>
            <View style={styles.gridContainer}>
                <PackshotGrid items={genreAssets} onItemPress={handlePackshotPress} />
                {isLoading && <Loader />}
            </View>
        </View>
    );
};

GenreScreen.displayName = 'GenreScreen';

// Add webHeaderProps to make the header fullWidth
const webHeaderProps: Partial<WithWebHeaderProps> = {
    fullWidth: true,
    hasMargin: false,
    noVerticalMargin: true,
};

// For default export, use the full width header version
export default (props: GenreWebProps) =>
    withWebHeader(GenreScreen)({ ...props, ...webHeaderProps });
